import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['disabledButton'];

  toggleDisabledButton(e) {
    if (e.currentTarget.checked) {
      this.disabledButtonTarget.disabled = false;
    } else {
      this.disabledButtonTarget.disabled = true;
    }
  }
}
